/*
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-01-23 11:29:04
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-05-09 17:07:00
 * @FilePath: \h5-lcjc-formula\src\utils\category\Pedi.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 儿科学 */

/** 对应的标题 */
const categoryMap = {
  'Kocher': 'Kocher 诊断标准',
  'CATCH': 'CATCH 规则',
  'PediatricTraumaScore': '儿科创伤评分',
  'GlasgowComaScale': 'Glasgow 昏迷评分',
  'GlasgowComaScalePed': 'Glasgow 昏迷评分（儿科）',
  'PRAM': 'PRAM 评分',
  'SilvermanAnderson': 'Silverman-Anderson',
  'PECARN': 'PECARN 算法',
  'WestleyCroup': 'Westley严重程度评分',
  'MaintenanceFluidPed': '维持补液量（儿童）',
  'UmbilicalLine': '脐血管置管长度',
  'BATiC': '钝器致儿童腹部外伤评分',
  'TargetHeight': '理想身高',
  // 'UrineOutput': '尿量',
  'PELD': 'PELD 评分',
  'PediatricTubeSize': '气管内插管尺寸（儿科）',
  'TubularPhosphateReabsorption': '肾小管磷重吸收',
  'BSA': '体表面积',
  'WETFAG': 'WETFAG',
  'BowelLength': '消化道长度估算',
  'LaryngealObstruction': '喉梗阻分级',
  'StageOfChildrenAge': '儿童年龄分期特点与建议',
  'DCFC_Age': '儿童药物剂量计算（年龄）',
  'DCFC_Weight': '儿童用药剂量计算（体重）',
  'DCFC_BSA': '儿童用药剂量计算（体表面积）',
  'L_T4_Child': '儿童L-T4替代治疗参考剂量',
  'IDOPEI': '小儿气管导管内径计算',
  'HydroxyprolineInUrine': '尿羟脯氨酸指数',
  'Comfort': 'comfort评分',
  'GHD': '生长激素刺激试验',
  'SGAAS': '简易胎龄评估量表',
  'NYU_PHFI': '儿童心衰指数评分（纽约大学）',
  'KDCriteria': '川崎病KD的诊断标准',
  'ComplementaryFoodsToInfants': '婴儿添加辅食的步骤和方法',
  'InfantHeartFailureGradingScale': '婴儿心衰分级评分表',
  'InfantNutrientNeeds': '婴儿营养素的需要',
  'HeightAndAgePercentileOfInfants': '婴幼儿（<36个月）身长年龄百分比',
  'WeightAndAgePercentileOfInfants': '婴幼儿（<36个月）体重年龄百分比',
  'HeadCircumferenceAndAgePercentileOfInfants': '婴幼儿（<36个月）头围年龄百分比',
  'HeightAndHeightPercentileOfInfants': '婴幼儿（<36个月）体重身长百分比',
  'RateOfWeightGainInPretermInfants': '早产儿体重增长速度',
  Neonatal_shock_scale:'新生儿休克评分表',
  DOWNE_score_for_neonatal_respiration:'新生儿Downes评分法',
  Galactose:"半乳糖",
  Phenylalanine:'丙氨酸'
}
/** 对应的描述 */
const categoryDescMap = {
  'Kocher': '用于儿童化脓性关节炎',
  'CATCH': '儿童头部损伤时是否行 CT 扫描？',
  'PediatricTraumaScore': '用于预测死亡率',
  'GlasgowComaScale': '应用广泛的昏迷评分',
  'GlasgowComaScalePed': '适用于儿科',
  'PRAM': '儿科急性哮喘严重度评估',
  'PECARN': '儿童头部创伤后是否需要 CT 检查',
  'WestleyCroup': '评估哮吼严重度',
  'MaintenanceFluidPed': '儿科补液计算器',
  'UmbilicalLine': '脐血管导管的内置长度',
  'BATiC': '儿童腹部钝器伤',
  'TargetHeight': '预测成人身高',
  // 'UrineOutput': '根据一段时间的排尿量计算每小时尿量',
  'PELD': '儿科肝移植评分',
  'PediatricTubeSize': '预测气管内插管尺寸',
  'QpQs': '肺体循环血流比',
  'TubularPhosphateReabsorption': '监测甲状旁腺机能亢进',
  'BSA': '体表面积估算',
  'WETFAG': '儿童复苏的快速计算',
  'BowelLength': '儿科消化道长度预测模型',
  'LaryngealObstruction': '评估喉梗阻严重度',
  'StageOfChildrenAge': '',
  'DCFC_Age': '用小儿年龄计算合适的药物剂量',
  'DCFC_Weight': '基于体重计算小儿用药剂量',
  'DCFC_BSA': '根据体表面积计算儿童合理用药剂量',
  'L_T4_Child': '不同年龄先天性甲减患儿的甲状腺素剂量',
  'IDOPEI': '小儿气管内插管导管型号的选择',
  'HydroxyprolineInUrine': '反应儿童营养状况',
  'Comfort': '适用于小儿患者的疼痛评估',
  'GHD': '判断儿童垂体分泌生长激素（GH）的功能',
  'InfantHeartFailureGradingScale': '评估婴儿心衰等级',
  'HeightAndAgePercentileOfInfants': '评估婴幼儿身高是否达标',
  'WeightAndAgePercentileOfInfants': '评估婴幼儿体重是否达标',
  'HeadCircumferenceAndAgePercentileOfInfants': '评估婴幼儿头围是否达标'
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Pedi.js